import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function ClubCTA() {
  const enabled = useSectionEnabled("club");
  const { cms } = useCMS();
  if (!enabled) return null;
  const c = cms?.club || {};

  return (
    <section id="club" className="bg-white py-14 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#FFF1E5] via-[#FFE6D6] to-[#FFD0B8] p-7 sm:p-10 lg:p-14">
          <div className="grid lg:grid-cols-[1.4fr_1fr] gap-8 items-center">
            <div>
              <span className="inline-flex items-center gap-1 bg-white/70 backdrop-blur px-3 py-1 rounded-full text-xs font-bold text-[#B23B12] uppercase tracking-wider">
                <Sparkles className="w-3.5 h-3.5" /> {c.badge || "Mover Club"}
              </span>
              <h2 className="lm-font font-extrabold text-[#11151C] text-2xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
                {c.title}
              </h2>
              <p className="text-[#11151C]/75 mt-4 text-base sm:text-lg max-w-xl">{c.description}</p>
              <a
                href={c.ctaUrl || "#club-explore"}
                className="lm-btn-primary mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm"
              >
                {c.ctaText || "Explore Mover Club"} <ArrowRight className="w-4 h-4" />
              </a>
            </div>
            <div className="grid grid-cols-3 gap-3 sm:gap-4">
              {(c.plugins || []).map((p) => (
                <div key={p} className="aspect-square bg-white rounded-2xl shadow-sm flex items-center justify-center text-center px-2">
                  <span className="lm-font font-bold text-[#11151C] text-xs sm:text-sm">{p}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
